export default __webpack_public_path__ + "static/media/PascaMyers.3180bc17.jpg";